<template>
    <div v-if="planningItem">
        <div>
            <md-button @click="goBack()" id="back-btn" style="padding: 0px; margin: 0px">
                <md-icon>keyboard_arrow_left</md-icon>
                back
            </md-button>
        </div>
        <div>
            <div class="md-headline">
                {{ planningItem.planning_item_type }} - {{ planningItem.planning_item_type_number }}
            </div>
            {{
                planningItem.client
                    ? (planningItem.client.first_name ? planningItem.client.first_name : '-') +
                      ' ' +
                      (planningItem.client.last_name ? planningItem.client.last_name : '-')
                    : planningItem.lead.data
                    ? planningItem.lead.data.first_name + ' ' + planningItem.lead.data.last_name
                    : ''
            }}
            <div class="md-layout-item">
                <div style="margin-top: 5px; margin-bottom: 10px">
                    {{ actionOptions.find(x => x.value === visitReport.state).text }}
                </div>
                <md-field>
                    <label>Commentaar</label>
                    <md-textarea id="report-comment" required v-model="visitReport.data.comment"></md-textarea>
                </md-field>
                <md-button @click="updateReport()" class="md-primary md-raised" id="btn-submit">Opslaan</md-button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import * as toastr from 'toastr';
import { appStore } from '@/store';
import {
    IPlanningItemEntity,
    IPlanningItemReportEntity,
    PlanningItemReportApi,
    PlanningItemReportState,
} from '@phrospr/api-backend';
import { getReportActionOptions } from '@phrospr/lib-core/src/engine/planning-item.engine';

@Component({
    components: {},
})
export default class VisitReportEditView extends Vue {
    actionOptions: Array<{ text: string; value: PlanningItemReportState }> = [];

    constructor() {
        super();
        if (!this.planningItem || !this.visitReport) {
            this.$router.push('/planning');
            return;
        }
        this.actionOptions = getReportActionOptions(this.planningItem.planning_item_type, true);
    }

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    get visitReport(): IPlanningItemReportEntity {
        return this.$store.state.editVisitReport;
    }

    public goBack() {
        this.$router.back();
    }

    public async updateReport() {
        try {
            await PlanningItemReportApi.updatePlanningItemReport(this.visitReport.planning_item_report_id, {
                comment: this.visitReport.data.comment,
            });
            await appStore.dispatch('refreshPlanningItem');
            await this.$router.back();
        } catch (e) {
            console.error(e);
            toastr.error('update failed');
        }
    }
}
</script>

<style scoped></style>
